import React from 'react'
import * as R from 'remeda'

import { type Question, useSurveyQueryQuestions } from '~/hooks/useSurveyQuery'

import { useAtomValueContext } from '../providers/AtomsProvider'

export const useGroupedQuestions = () => {
  const allQuestions = useSurveyQueryQuestions()
  const questionQueryData = useAtomValueContext('questionQueryData')

  return React.useMemo<
    [normalQuestions: Question[], matrixQuestions: Question[]]
  >(
    () =>
      R.pipe(
        allQuestions,
        R.intersectionWith(
          questionQueryData?.questions ?? [],
          (question, questionId) => question.question_id === questionId,
        ),
        R.partition((question) => question.mt_questions.length === 0),
      ),
    [allQuestions, questionQueryData?.questions],
  )
}
